export default __webpack_public_path__ + "static/media/DocStopFill.4f064635.svg";